import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button, Card, Alert } from 'react-bootstrap';
import { signInRequest } from '../../store/modules/auth/doctor/actions';
import logo from '../../assets/logo.png';
import RecuperarSenhaModal from '../../components/RecuperarSenhaModal';

export default function SignInMed() {
  const dispatch = useDispatch();
  const authError = useSelector(state => state.doctor.authError);
  const [validated, setValidated] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();

    if (!event.currentTarget.checkValidity()) {
      event.stopPropagation();
    } else {
      const cpf = event.target.elements.formBasicCPF.value;
      const senha = event.target.elements.formBasicSenha.value;
      dispatch(signInRequest(cpf, senha));
    }

    setValidated(true);
  };

  return (
    <>
      <Card className="m-5 mx-auto" style={{ maxWidth: '300px' }}>
        <Card.Body>
          <div className="text-center">
            <img src={logo} alt="logoImagem" width={70} height={70} />
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="p-3">
              <Form.Group controlId="formBasicCPF">
                <Form.Label>CPF do Médico</Form.Label>
                <Form.Control required type="text" placeholder="Seu CPF" />
                <Form.Control.Feedback type="invalid">
                  Digite seu CPF.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formBasicSenha">
                <Form.Label>Senha</Form.Label>
                <Form.Control
                  required
                  type="password"
                  placeholder="Sua senha secreta"
                />
                <Form.Control.Feedback type="invalid">
                  Digite sua senha.
                </Form.Control.Feedback>
              </Form.Group>
              {authError && (
                <Alert variant="danger" className="mb-3">
                  {authError}
                </Alert>
              )}

              <Button block type="submit">
                Entrar
              </Button>
              <Button
                variant="warning"
                block
                onClick={() => setShowResetPasswordModal(true)}
              >
                Esqueci minha senha
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>

      <RecuperarSenhaModal
        showResetPasswordModal={showResetPasswordModal}
        setShowResetPasswordModal={setShowResetPasswordModal}
        userType="medico"
      />
    </>
  );
}
